import * as React from 'react';
import { Box } from '@mui/material';
import styles from '../css/rdTrf.module.css';
import VmsDisplayView from 'pages/components/dashboard/SwItsGetVmsDisplayView';
import { SwItsParkingCntTotalProvider, SwItsParkingCntTotalInfo } from 'pages/components/dashboard/SwItsGetParkingCnt';
import { SwItsTrafficOdProvider, SwItsTrafficOdMapChart } from 'pages/components/dashboard/SwitsTrafficOdData';
import { SwItsTrafficTotalProvider, SwItsTrafficTotalBarChart } from 'pages/components/dashboard/SwitsTrafficTotalData';
import  FacilityStatusView from 'pages/components/dashboard/SwItsFacilityStatus';
import RoadTrafficFuc from "../tmp/RoadTrafficFuc";
import TimeDisplay from '../components/TimeDisplay';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation'; 
import { SwItsTrafficInOutProvider, SwItsTrafficInOutView } from 'pages/components/dashboard/SwItsTrafficInOutView';
import {useEffect} from "react"
import { useTranslation } from 'react-i18next';
export default function RoadTrafficViewM() {
    const [currentTimeIndex, setCurrentTimeIndex] = React.useState(0);
    const [range, setRange] = React.useState('day');
    const { mapMessages, clearLastMapMessage } = useDashboard(); 

    const { t, i18n } = useTranslation();

    useEffect(() => {
            const handleStorageChange = (e) => {
                if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
                    i18n.changeLanguage(e.newValue);
                }
            };
    
            window.addEventListener('storage', handleStorageChange);
            return () => window.removeEventListener('storage', handleStorageChange);
        }, [i18n]);
    
    useNavigation(mapMessages);

    useEffect(() => {
        if (mapMessages.length > 0) {
          clearLastMapMessage(); 
        }
      }, [mapMessages]); 

    return (
        <Box sx={{ height: "100%", width: "100%" }}>
            <div className="container">
                <div className="contWrap L_lmr">
                    <div className="inner L_3m"> {/*통행속도 현황 제거, VMS 현황 추가*/ }
                        <div className="titWrap flx a_center j_spc_btw">
                             <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-04)'}}>{t('VMSstatus')}</h2>
                        </div>
                        <div className={`${styles.boxCont_rd_l}`}>
                            <div style={{width: '100%', height:'100%'}}>
                                <VmsDisplayView />
                            </div>
                        </div>
                    </div>
                    <div className="L_3m L_tb">
                        <div className={`${styles.itsFcl_rdTrf} inner L_d flx_col`}>
                            <div className="titWrap flx a_center j_spc_btw">
                                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-05)', letterSpacing:'-4px'}}>{t('ITSEquipmentOperationStatus')}</h2>
                            </div>
                            <FacilityStatusView/>
                        </div>
                        <div className={`${styles.gap60} inner L_d flx_col`}>
                            <div className="titWrap flx a_center j_spc_btw">
                               <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}  style={{color:'var(--iv-06)'}}>{t('TrafficVolumeStatistics')}</h2>
                            </div>
                            <SwItsTrafficTotalProvider>
                                <div className={`${styles.boxCont_rd}`}>
                                    <SwItsTrafficTotalBarChart />
                                </div>
                            </SwItsTrafficTotalProvider>
                        </div>
                    </div>
                    <div className="L_3m L_tb">
                        <div className={`${styles.gap60} inner L_d flx_col`}>
                            <div className="titWrap flx a_center j_spc_btw">
                                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-07)'}}>{t('InboundOutboundTraffic')}</h2>
                            </div>
                            <div className={`${styles.boxCont_rd_l}`}>
                                {/* <div style={{width: '100%', height:'100%'}}>
                                    <VmsDisplayView />
                                </div> */}
                            <div style={{ width: '100%', height: '100%' }}>
                                <SwItsTrafficOdProvider>
                                     <SwItsTrafficOdMapChart
                                     currentTimeIndex={currentTimeIndex}
                                     setCurrentTimeIndex={setCurrentTimeIndex}
                                     />
                                </SwItsTrafficOdProvider>
                            </div>
                            </div>
                        </div>
                        <div className={`${styles.gap60} inner L_d flx_col`}>
                            <div className="titWrap flx a_center j_spc_btw">
                                 <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-10)'}}>{t('PublicParkingOperation')}</h2>
                            </div>
                            <SwItsParkingCntTotalProvider>
                                <SwItsParkingCntTotalInfo />
                            </SwItsParkingCntTotalProvider>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    );
}
